import React from 'react';
import { AlertTriangle, CheckCircle, Clock, XCircle } from 'lucide-react';

interface ClientHealthBadgeProps {
	health: {
		status: 'healthy' | 'warning' | 'error';
		issues: string[];
	};
}

export const ClientHealthBadge: React.FC<ClientHealthBadgeProps> = ({ health }) => {
	const getHealthIcon = () => {
		switch (health.status) {
			case 'healthy':
				return <CheckCircle className="h-4 w-4 text-green-500" />;
			case 'warning':
				return <AlertTriangle className="h-4 w-4 text-yellow-500" />;
			case 'error':
				return <XCircle className="h-4 w-4 text-red-500" />;
			default:
				return <Clock className="h-4 w-4 text-gray-500" />;
		}
	};

	return (
		<div className="flex items-center space-x-2">
			{getHealthIcon()}
			<span className="text-sm capitalize">{health.status}</span>
		</div>
	);
};
